import * as yup from 'yup';

export const facturacionElectronicaFormSchema = yup.object({
  razon_social: yup
    .string()
    .required('El campo razon social es requerido')
    .max(200, 'El campo razon social no debe exceder los 200 caracteres'),
  nombre_comercial: yup
    .string()
    .required('El campo nombre comercial es requerido')
    .max(200, 'El campo nombre comercial no debe exceder los 200 caracteres'),
  telefono: yup
    .string()
    .required('El campo telefono es requerido')
    .max(200, 'El campo telefono no debe exceder los 200 caracteres'),
  direccion: yup
    .string()
    .required('El campo direccion es requerido')
    .max(200, 'El campo direccion no debe exceder los 200 caracteres'),
  obligado_contabilidad: yup
    .boolean()
    .typeError('El campo obligado contabilidad es requerido')
    .required('El campo obligado contabilidad es requerido'),
  es_contribuyente_especial: yup
    .boolean()
    .typeError('El campo es contribuyente especial es requerido')
    .required('El campo es contribuyente especial es requerido'),
  es_gran_contribuyente: yup
    .boolean()
    .typeError('El campo es gran contribuyente es requerido')
    .required('El campo es gran contribuyente es requerido'),
  es_agente_retencion: yup
    .boolean()
    .typeError('El campo es agente retencion es requerido')
    .required('El campo es agente retencion es requerido'),
  es_exportador: yup
    .boolean()
    .typeError('El campo es exportador es requerido')
    .required('El campo es exportador es requerido'),
  tipo_exportador: yup
    .string()
    .optional()
    .when('es_exportador', {
      is: true,
      then: schema => schema.required('El campo tipo exportador es requerido'),
    })
    .max(200, 'El campo tipo exportador no debe exceder los 200 caracteres'),
  tipo_agente_retencion: yup
    .string()
    .required('El campo tipo agente retencion es requerido')
    .max(
      200,
      'El campo tipo agente retencion no debe exceder los 200 caracteres'
    ),

  // 3 digits separated by commas
  establecimiento_punto_emision: yup
    .string()
    .required('El campo establecimiento punto emision es requerido')
    .test(
      'is-valid-establecimiento',
      'Ingrese establecimientos validos separados por comas',
      value => {
        const establecimientos = value.split(',');
        return establecimientos.every(establecimiento => {
          return establecimiento.length === 3;
        });
      }
    ),

  mensaje_personalizado: yup
    .string()
    .required('El campo mensaje personalizado es requerido')
    .max(
      200,
      'El campo mensaje personalizado no debe exceder los 200 caracteres'
    ),
  clave_firma: yup
    .string()
    .required('El campo clave firma es requerido')
    .max(200, 'El campo clave firma no debe exceder los 200 caracteres'),
  clave_autorizadora: yup
    .string()
    .required('El campo clave autorizadora es requerido')
    .max(200, 'El campo clave autorizadora no debe exceder los 200 caracteres'),

  firmar_automaticamente: yup
    .boolean()
    .typeError('El campo firmar automaticamente es requerido')
    .required('El campo firmar automaticamente es requerido'),

  ///* secuanciales JSON ==================
  factura: yup
    .string()
    .typeError('El campo factura es requerido')
    .required('El campo factura es requerido')
    .max(9, 'El campo factura no debe exceder los 9 caracteres'),
  nota_credito: yup
    .string()
    .typeError('El campo nota credito es requerido')
    .required('El campo nota credito es requerido')
    .max(9, 'El campo nota credito no debe exceder los 9 caracteres'),
  nota_debito: yup
    .string()
    .typeError('El campo nota debito es requerido')
    .required('El campo nota debito es requerido')
    .max(9, 'El campo nota debito no debe exceder los 9 caracteres'),
  guia_remision: yup
    .string()
    .typeError('El campo guia remision es requerido')
    .required('El campo guia remision es requerido')
    .max(9, 'El campo guia remision no debe exceder los 9 caracteres'),
  retencion: yup
    .string()
    .typeError('El campo retencion es requerido')
    .required('El campo retencion es requerido')
    .max(9, 'El campo retencion no debe exceder los 9 caracteres'),
  liquidacion_compra: yup
    .string()
    .typeError('El campo liquidacion compra es requerido')
    .required('El campo liquidacion compra es requerido')
    .max(9, 'El campo liquidacion compra no debe exceder los 9 caracteres'),
  proforma: yup
    .string()
    .typeError('El campo proforma es requerido')
    .required('El campo proforma es requerido')
    .max(9, 'El campo proforma no debe exceder los 9 caracteres'),

  ///* fk ==================
  ciudad: yup
    .string()
    .required('El campo ciudad es requerido')
    .max(200, 'El campo ciudad no debe exceder los 200 caracteres'),
  establecimiento: yup
    .string()
    .required('El campo establecimiento es requerido')
    .max(200, 'El campo establecimiento no debe exceder los 200 caracteres'),
  tipo_contribuyente: yup
    .string()
    .required('El campo tipo contribuyente es requerido')
    .max(200, 'El campo tipo contribuyente no debe exceder los 200 caracteres'),
});
